import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PayRollState } from './pay-roll.state';

export const selectPayRollState =
  createFeatureSelector<PayRollState>('payRoll');

export const selectPayRollBatches = createSelector(
  selectPayRollState,
  (state: PayRollState) => state.payRollBatches
);

export const selectCurrentPayRollBatch = createSelector(
  selectPayRollState,
  (state: PayRollState) => state.currentPayRollBatch
);

export const selectCurrentPayRoll = createSelector(
  selectPayRollState,
  (state: PayRollState) => state.currentPayRoll
);

export const selectPayRollsFetchedAt = createSelector(
  selectPayRollState,
  (state: PayRollState) => state.fetchedAt
);
